module.exports = __webpack_public_path__ + "img/wechat-code.68745756.png";